import React from "react";
import { motion } from "framer-motion";
import { Calendar, Tag, ArrowRight } from "lucide-react";

const PromoCard = ({ promo, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="group bg-card rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-border"
    >
      {/* Image */}
      <div className="relative h-48 md:h-56 overflow-hidden">
        <img
          src={`/${promo.image}`}
          alt={promo.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          loading="lazy"
          onError={(e) => {
            e.currentTarget.src = "/assets/no-image.png";
          }}
        />

        {promo.discount && (
          <div className="absolute top-4 left-4 bg-primary text-primary-foreground px-3 py-1 rounded-full text-xs font-bold">
            {promo.discount}
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-lg font-bold text-card-foreground mb-2 line-clamp-2">
          {promo.title}
        </h3>

        <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
          {promo.description}
        </p>

        <div className="flex items-center gap-2 text-xs text-muted-foreground mb-4">
          <Calendar size={14} />
          <span>{promo.period}</span>
        </div>

        <button className="inline-flex items-center gap-2 text-primary font-semibold text-sm group-hover:gap-3 transition-all">
          Lihat Detail
          <ArrowRight size={16} />
        </button>
      </div>
    </motion.div>
  );
};

export default PromoCard;
